// ======================================================================
// File Name       : usageSettingLive
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import moment from 'moment';
import $ from 'jquery';
import * as ActionTypes from '../constants/actionTypes/usageSettingLive';
import { mapUserSecernIdWithGroupName } from '../utils/UserUtils';
import { displayMinutes, parseDateForDetail } from '../utils/index';

const initialState = {
  liveReservationTime: {
    enableReservingTime: 0,
    reservingTime: 0,
    enableReservingTimeTxt: '',
    reservingTimeTxt: '',
  },
  liveReserves: {
    allSecernIds: [],
    bySecernIds: {},
  },
  liveUserCounts: {
    allSecernIds: [],
    bySecernIds: {},
  },
  storedUserList: {
    allSecernIds: [],
    bySecernIds: {},
  },
  storedEdittingUsers: {
    bySecernIds: {},
    allSecernIds: [],
  },
  userAttributeList: [],
  liveReserveDetail: {},
  userLiveRelationList: [],
  liveReserveRecordNum: 0,
  liveAuthorityIdList: [],
  joinableLives: {
    userSecernId: '',
    liveList: [],
  },
  durationLiveDetail: 0,
  serviceInfo: {},
  onewayLiveEntryLimit: 0,
  twowayLiveEntryLimit: 0,
  userLiveRecordedFileList: [],
};

export default function usageSettingLive(state = initialState, action) {
  switch (action.type) {
    case ActionTypes.RECEIVED_LIVE_RESERVATION_TIME: {
      const { liveReservationTimeRes } = action;
      const liveReservationTime = {
        enableReservingTime: 0,
        reservingTime: 0,
      };
      if (liveReservationTimeRes) {
        const enableReservingTime = parseInt(liveReservationTimeRes.enableReservingTime, 10);
        const reservingTime = parseInt(liveReservationTimeRes.reservingTime, 10);
        if (!isNaN(enableReservingTime)) {
          liveReservationTime.enableReservingTime = enableReservingTime;
          liveReservationTime.enableReservingTimeTxt = displayMinutes(enableReservingTime - reservingTime);
        }
        if (!isNaN(reservingTime)) {
          liveReservationTime.reservingTime = reservingTime;
          liveReservationTime.reservingTimeTxt = displayMinutes(reservingTime);
        }
      }
      return {
        ...state,
        liveReservationTime,
      };
    }
    case ActionTypes.RECEIVED_SERVICE_INFO: {
      const { serviceInfo } = action;
      let onewayLiveEntryLimit = 0;
      let twowayLiveEntryLimit = 0;
      if (
        serviceInfo &&
        serviceInfo.usageSettingInfo &&
        serviceInfo.usageSettingInfo.onewayLiveEntryLimit &&
        serviceInfo.usageSettingInfo.twowayLiveEntryLimit
      ) {
        onewayLiveEntryLimit = serviceInfo.usageSettingInfo.onewayLiveEntryLimit;
        twowayLiveEntryLimit = serviceInfo.usageSettingInfo.twowayLiveEntryLimit;
      }
      return {
        ...state,
        serviceInfo,
        onewayLiveEntryLimit,
        twowayLiveEntryLimit,
      };
    }
    case ActionTypes.RECEIVED_LIVE_RESERVED_LIST: {
      const { liveList, recordNum, userListToStore, liveUserCountList } = action;
      const { storedUserList } = state;
      const liveUserCounts = liveUserCountList.reduce(
        (acc, cur) => {
          if (cur.liveSecernId) {
            if (acc.allSecernIds.indexOf(cur.liveSecernId) < 0) {
              acc.allSecernIds.push(cur.liveSecernId);
            }
            if (!acc.bySecernIds[cur.liveSecernId]) {
              acc.bySecernIds[cur.liveSecernId] = cur;
            }
          }
          return acc;
        },
        {
          allSecernIds: [],
          bySecernIds: {},
        },
      );
      const newStoredUserList = userListToStore.reduce(
        (acc, cur) => {
          if (cur.userSecernId) {
            const userSecernId = cur.userSecernId;
            if (acc.allSecernIds.indexOf(userSecernId) < 0) {
              acc.allSecernIds.push(userSecernId);
            }
            if (!acc.bySecernIds[userSecernId]) {
              acc.bySecernIds[userSecernId] = cur;
            }
          }
          return acc;
        },
        {
          bySecernIds: storedUserList.bySecernIds,
          allSecernIds: storedUserList.allSecernIds,
        },
      );
      const liveReserves = liveList.reduce(
        (acc, cur) => {
          if (cur.liveSecernId) {
            acc.allSecernIds.push(cur.liveSecernId);
            if (liveUserCounts.bySecernIds[cur.liveSecernId]) {
              cur.invitedUserCount =
                liveUserCounts.bySecernIds[cur.liveSecernId].invitedUserCount || 0;
              cur.attendedUserCount =
                liveUserCounts.bySecernIds[cur.liveSecernId].attendedUserCount || 0;
            }
            acc.bySecernIds[cur.liveSecernId] = cur;
          }
          if (
            cur.organizerUserSecernId &&
            newStoredUserList.bySecernIds[cur.organizerUserSecernId]
          ) {
            cur.organizerName =
              newStoredUserList.bySecernIds[cur.organizerUserSecernId].userName || '';
          }
          return acc;
        },
        {
          allSecernIds: [],
          bySecernIds: {},
        },
      );
      return {
        ...state,
        liveReserves,
        liveReserveRecordNum: recordNum,
        storedUserList: newStoredUserList,
        liveUserCounts,
      };
    }
    case ActionTypes.RECEIVED_LIVE_RESERVED_DETAIL: {
      const { liveReserveDetail, storedUserList, userLiveRelationList, userAttributeList, userLiveRecordedFileList } = action;

      const formInitialValues = { ...liveReserveDetail };

      if (
        liveReserveDetail.organizerUserSecernId &&
        storedUserList[liveReserveDetail.organizerUserSecernId]
      ) {
        const organizerInfo = storedUserList[liveReserveDetail.organizerUserSecernId];
        liveReserveDetail.organizerName = organizerInfo.userName || '';
      }
      const liveSecernId = liveReserveDetail.liveSecernId;
      const newUserLiveRelationList = userLiveRelationList.reduce(
        (acc, cur) => {
          if (
            cur.participantUserSecernId &&
            cur.liveSecernId === liveSecernId &&
            storedUserList[cur.participantUserSecernId]
          ) {
            const userInfo = storedUserList[cur.participantUserSecernId];
            acc.allSecernIds.push(cur.participantUserSecernId);
            acc.bySecernIds[cur.participantUserSecernId] = userInfo;
          }
          return acc;
        },
        {
          bySecernIds: {},
          allSecernIds: [],
        },
      );

      formInitialValues.liveStartFrom &&
        (formInitialValues.liveStartFrom = moment(formInitialValues.liveStartFrom));
      formInitialValues.liveStartTo &&
        (formInitialValues.liveStartTo = moment(formInitialValues.liveStartTo));
      if (formInitialValues.organizerUserSecernId) {
        formInitialValues.selectedUserId = formInitialValues.organizerUserSecernId;
        formInitialValues.edittingUserId = formInitialValues.organizerUserSecernId;
      }
      if (userAttributeList && userAttributeList.length) {
        formInitialValues.userAttributes = [];
        userAttributeList.reduce((acc, cur) => {
          if (cur && cur.userAttributeKeyNum && cur.userAttribute) {
            const keyNum = parseInt(cur.userAttributeKeyNum, 10) - 1;
            formInitialValues.userAttributes[keyNum] = cur.userAttribute;
          }
          return acc;
        }, []);
      }
      const storedEdittingUsers = $.extend(true, {}, newUserLiveRelationList);
      const edittingUsers = $.extend(true, {}, newUserLiveRelationList);
      if (edittingUsers && edittingUsers.allSecernIds && edittingUsers.allSecernIds.length) {
        const edittingUserList = {};
        const length = edittingUsers.allSecernIds.length;
        for (let i = 0; i < length; i++) {
          const userSecernId = edittingUsers.allSecernIds[i];
          edittingUserList[userSecernId] = true;
        }
        liveReserveDetail.edittingUserList = $.extend(true, {}, edittingUserList);
        formInitialValues.edittingUserList = $.extend(true, {}, edittingUserList);
        formInitialValues.storedEdittingUserList = $.extend(true, {}, edittingUserList);
      }
      const liveStartFromDetail = moment(liveReserveDetail.liveStartFrom);
      const liveStartToDetail = moment(liveReserveDetail.liveStartTo);
      const durationLiveDetail = liveStartToDetail.diff(liveStartFromDetail, 'minutes');

      const newUserLiveRecordedFileList = userLiveRecordedFileList.reduce(
        (acc, cur) => {
          acc.allRecordIds.push(cur.recordId);
          acc.byRecordIds[cur.recordId] = cur;
          return acc;
        },
        {
          byRecordIds: {},
          allRecordIds: [],
        },
      );

      return {
        ...state,
        liveReserveDetail,
        formInitialValues,
        userLiveRelationList: newUserLiveRelationList,
        userAttributeList,
        edittingUsers,
        storedEdittingUsers,
        durationLiveDetail,
        userLiveRecordedFileList: newUserLiveRecordedFileList,
      };
    }
    case ActionTypes.ADD_USER_LIST_TO_LIVE: {
      const { userListToAdd, storedUserList } = action;
      let edittingUsers = {
        bySecernIds: {},
        allSecernIds: [],
      };
      if (userListToAdd && storedUserList) {
        edittingUsers = userListToAdd.reduce(
          (acc, cur) => {
            if (storedUserList[cur]) {
              acc.bySecernIds[cur] = storedUserList[cur];
              acc.allSecernIds.push(cur);
            }
            return acc;
          },
          {
            bySecernIds: {},
            allSecernIds: [],
          },
        );
      }
      return {
        ...state,
        edittingUsers,
      };
    }
    case ActionTypes.REMOVE_USER_FROM_LIVE: {
      const { userSecernId } = action;
      const { edittingUsers } = state;
      if (userSecernId && edittingUsers) {
        if (edittingUsers.bySecernIds && edittingUsers.bySecernIds[userSecernId]) {
          delete edittingUsers.bySecernIds[userSecernId];
        }
        if (edittingUsers.allSecernIds) {
          const pos = edittingUsers.allSecernIds.indexOf(userSecernId);
          if (pos > -1) {
            edittingUsers.allSecernIds.splice(pos, 1);
          }
        }
      }
      return {
        ...state,
        edittingUsers,
      };
    }
    case ActionTypes.SAVE_LIVE_AUTHORITY_IDS: {
      const { liveAuthorityIdList } = action;
      return {
        ...state,
        liveAuthorityIdList,
      };
    }
    case ActionTypes.RESET_EDITING_LIVE_USERS: {
      const edittingUsers = {
        bySecernIds: {},
        allSecernIds: [],
      };
      const storedEdittingUsers = {
        bySecernIds: {},
        allSecernIds: [],
      };
      const formInitialValues = {};
      return {
        ...state,
        edittingUsers,
        storedEdittingUsers,
        formInitialValues,
      };
    }
    case ActionTypes.RECEIVE_JOINABLE_LIVE_LIST: {
      const { joinableLives } = action;
      return {
        ...state,
        joinableLives,
      };
    }
    case ActionTypes.REMOVE_ALL_USER_FROM_LIST: {
      const edittingUsers = {
        allSecernIds: [],
        bySecernIds: {},
      };
      return {
        ...state,
        edittingUsers,
      };
    }
    // #7129 START
    case ActionTypes.RESET_LIVE_RESERVED_DETAIL: {
      const { liveReserveDetail } = initialState;
      return {
        ...state,
        liveReserveDetail,
      };
    }
    // #7129 END
    default: {
      return {
        ...state,
      };
    }
  }
}
